import { get, put, postAttachmentData, post } from './mainApi';

const leaveManagementServiceBaseURL = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;

export const updateCarryForwardedLeave = async (data) => {
    const response = put(`${leaveManagementServiceBaseURL}carry-forwarded-leaves/update-employee-carry-forward-leaves`, data);
    return response;
};

export const getCarryForwardedLeaves = async (pageNo, pageSize,filter, sort) => {

    let newUrl = `${leaveManagementServiceBaseURL}carry-forwarded-leaves?pageSize=${pageSize}&pageNo=${pageNo}`
    
    if(filter) {
        newUrl += `&filter=${filter}`
    }
    if(sort) {
        newUrl += `&sort=${sort}` 
    }
    
    const response = get(newUrl);
    return response;
}

export const bulkUpdateCarryForwardedLeaves = async (data) => {
    const response = put(`${leaveManagementServiceBaseURL}carry-forwarded-leaves/update-carry-forward-leaves`, {data});
    return response;
};